// 修改标签部署修复，去掉地域性元素
document.addEventListener('DOMContentLoaded', function () {
      // 处理现有的 hreflang 标签
      function processHreflangLinks() {
          const hreflangLinks = document.querySelectorAll('link[rel="alternate"][hreflang]');
          hreflangLinks.forEach(function (link) {
              try {
                  let hreflang = link.getAttribute('hreflang');
                  if (hreflang.includes('-US')) {
                      hreflang = hreflang.replace('-US', '');
                      link.setAttribute('hreflang', hreflang);
                  }
              } catch (error) {
                  console.error('处理 hreflang 标签时出错:', error);
              }
          });
      }

      // 处理现有的标签
      processHreflangLinks();

      // 使用 MutationObserver 监听 DOM 变化，处理动态加载的标签
      const observer = new MutationObserver(function (mutationsList) {
          for (const mutation of mutationsList) {
              if (mutation.type === 'childList') {
                  processHreflangLinks();
              }
          }
      });

      // 开始监听 <head> 元素的变化
      const head = document.querySelector('head');
      if (head) {
          observer.observe(head, { childList: true });
      }
  });
  
	// document.addEventListener('DOMContentLoaded', function() {
 //      const alternateLinks = document.querySelectorAll('link[rel="alternate"][hreflang]');
 //      alternateLinks.forEach(function(link) {
 //        let hreflang = link.getAttribute('hreflang');
 //        if (hreflang.includes('-US')) {
 //          hreflang = hreflang.replace('-US', '');
 //          link.setAttribute('hreflang', hreflang);
 //        }
 //      });
 //   });